import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";
export default {
  DoGetIssuedQuotationDashboard(_transactionIssuedOptionTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
      TransactionIssuedOptionTypeId: _transactionIssuedOptionTypeId,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedQuotationDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },

  DoGetIssuedInvoiceDashboard(_transactionIssuedOptionTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
      TransactionIssuedOptionTypeId: _transactionIssuedOptionTypeId,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedInvoiceDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetIssuedReceiptDashboard(_transactionIssuedOptionTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
      TransactionIssuedOptionTypeId: _transactionIssuedOptionTypeId,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedReceiptDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetIssuedTaxInvoiceDashboard(_transactionIssuedOptionTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
      TransactionIssuedOptionTypeId: _transactionIssuedOptionTypeId,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedTaxInvoiceDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetIssuedCreditNoteDashboard(_transactionIssuedOptionTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
      TransactionIssuedOptionTypeId: _transactionIssuedOptionTypeId,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedCreditNoteDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetIssuedBillingNoteDashboard(_transactionIssuedOptionTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
      TransactionIssuedOptionTypeId: _transactionIssuedOptionTypeId,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedBillingNoteDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetIssuedPODashboard(_transactionIssuedOptionTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
      TransactionIssuedOptionTypeId: _transactionIssuedOptionTypeId,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedPODashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetIssuedExpenseDashboard(_transactionIssuedOptionTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
      TransactionIssuedOptionTypeId: _transactionIssuedOptionTypeId,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedExpenseDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetIssuedPuchaseTaxInvoiceDashboard(_transactionIssuedOptionTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
      TransactionIssuedOptionTypeId: _transactionIssuedOptionTypeId,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedPuchaseTaxInvoiceDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetIssuedReceivedCreditNoteDashboard(_transactionIssuedOptionTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
      TransactionIssuedOptionTypeId: _transactionIssuedOptionTypeId,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedReceivedCreditNoteDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetIssuedCombinePaymentNoteDashboard(_transactionIssuedOptionTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
      TransactionIssuedOptionTypeId: _transactionIssuedOptionTypeId,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedCombinePaymentNoteDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetIssuedPurchaseAssetDashboard(_transactionIssuedOptionTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
      TransactionIssuedOptionTypeId: _transactionIssuedOptionTypeId,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetIssuedPurchaseAssetDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoCaptureTrialBalanceByMerchant() {
    let _input = {
      merchantId: userInfo.MerchantId()
    };
    return API.peakReportAPI
      .post("/api/DashBoard/CaptureTrialBalanceByMerchantId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
};
